export default __webpack_public_path__ + "static/media/11-63.babf1031.png";